import { Grid, Typography } from "@mui/material";
import { OutreachContact } from "schemas/dashboard";

import { formatEpochTimestamp } from "utils/time";

export default function ContactSource({
  contact,
}: {
  contact: OutreachContact;
}) {
  let contactSource = "";

  if (contact.source === "gmail_import") {
    contactSource = "This contact was created from gmail_import. ";
  } else if (contact.source === "user") {
    contactSource =
      "This contact was created by the user adding it in the tracking page. ";
  } else if (!contact.savedBrand) {
    if (contact.source === "bento") {
      contactSource = "This contact was never saved and was directly emailed. ";
    } else {
      contactSource = `This contact was never saved and came from this source "${contact.source}" (most likely, inbound or invited into a thread). `;
    }
  } else if (contact.savedBrand.isAdmin) {
    contactSource = `This contact was manually saved by an Admin user on ${formatEpochTimestamp(
      { epochTimestamp: contact.savedBrand.createdAt, addYear: true },
    )}. `;
  } else if (contact.savedBrand.createdByAutomation) {
    contactSource = `This contact was saved by an automation on ${formatEpochTimestamp(
      { epochTimestamp: contact.savedBrand.createdAt, addYear: true },
    )}. `;
  } else {
    contactSource = `This contact was saved by the user on ${formatEpochTimestamp(
      { epochTimestamp: contact.savedBrand.createdAt, addYear: true },
    )}. `;
  }

  if (contact.bentoContact) {
    if (contact.bentoContact.bestResponseType) {
      contactSource += `This contact best response type to a user is ${contact.bentoContact.bestResponseType}.`;
    } else {
      contactSource += "This contact has never responded to a user.";
    }
  }

  if (!contactSource) {
    return <></>;
  }

  return (
    <Grid item xs={12}>
      <Typography gutterBottom>
        <strong>Contact Source</strong>
      </Typography>
      <Typography variant="caption" paragraph color="textSecondary">
        {contactSource}
      </Typography>
    </Grid>
  );
}
